import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getAgentBranch = id => {
  return http.get(
    `${getBaseUrl()}/agent_branch/${id}`
  );
};

export const getAgentBranchFieldAndBranchTitles = () => {
  return http.get(
    `${getBaseUrl()}/agent_branch_field_branch_titles`
  );
};

export const getAgentBranchFieldAndBranchTitlesByAgentBranchIds = () => {
  return http.get(
    `${getBaseUrl()}/agent_branch_field_branch_titles_by_agent_branch_ids`
  );
};

export const getAgentBranchs = () => {
  return http.get(
    `${getBaseUrl()}/agent_branch`
  );
};

export const updateAgentBranch = data => {
  return http.put(
    `${getBaseUrl()}/agent_branch/${data.id}`,
    data
  );
};

export const submitAgentBranch = (data) => {
  return http.post(
    `${getBaseUrl()}/agent_branch`,
    data
  );
};
